export default __webpack_public_path__ + "static/media/BatchCheck_Dark2.7adc2854.svg";